/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import n from "prop-types";
import { validatePackage as y, classNames as v } from "@progress/kendo-react-common";
import { packageMetadata as C } from "../package-metadata.mjs";
const c = {
  pulsing: 2,
  "infinite-spinner": 3,
  "converging-spinner": 4
}, h = {
  pulsing: "k-loader-pulsing-2",
  "infinite-spinner": "k-loader-spinner-3",
  "converging-spinner": "k-loader-spinner-4"
}, d = r.forwardRef((a, p) => {
  y(C);
  const {
    className: t,
    style: u
  } = a, i = r.useRef(null), k = r.useCallback(
    () => {
      i.current && i.current.focus();
    },
    []
  );
  r.useImperativeHandle(p, () => ({
    element: i.current,
    focus: k
  }));
  const s = r.useMemo(
    () => a.size || l.size,
    [a.size]
  ), e = r.useMemo(
    () => a.themeColor || l.themeColor,
    [a.themeColor]
  ), o = r.useMemo(
    () => a.type || l.type,
    [a.type]
  ), g = r.useMemo(
    () => v(
      "k-loader",
      {
        "k-loader-sm": s === "small",
        "k-loader-md": s === "medium",
        "k-loader-lg": s === "large",
        "k-loader-primary": e === "primary",
        "k-loader-secondary": e === "secondary",
        "k-loader-tertiary": e === "tertiary",
        "k-loader-info": e === "info",
        "k-loader-success": e === "success",
        "k-loader-warning": e === "warning",
        "k-loader-error": e === "error",
        "k-loader-dark": e === "dark",
        "k-loader-light": e === "light",
        "k-loader-inverse": e === "inverse"
      },
      t,
      h[o]
    ),
    [
      s,
      e,
      t,
      o
    ]
  ), m = new Array(c[o]);
  return m.fill(0, 0, c[o]), /* @__PURE__ */ r.createElement("div", { className: g, style: u }, /* @__PURE__ */ r.createElement("div", { className: "k-loader-canvas" }, m.map((N, f) => /* @__PURE__ */ r.createElement("span", { key: f, className: "k-loader-segment" }))));
});
d.propTypes = {
  className: n.string,
  style: n.object,
  type: n.oneOf([
    "pulsing",
    "infinite-spinner",
    "converging-spinner"
  ]),
  size: n.oneOf(["small", "medium", "large"]),
  themeColor: n.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "inverse"
  ])
};
const l = {
  size: "medium",
  themeColor: "primary",
  type: "pulsing"
};
d.displayName = "KendoLoader";
export {
  d as Loader
};
